import Button from './button';

export default class Danger extends Button {
  get buttonVariant() {
    return 'destructive';
  }
}
